import React from "react";
import styled from "styled-components";

const RowWrapper = styled.div`
  ${(p) => p.inlineStyle.height && `height: ${p.inlineStyle.height}`}

  ${(p) => p.inlineCSS && p.inlineCSS};
`;

const Row = ({ children, extra = {} }) => {
  const { style = {}, css, className = "" } = extra;

  return (
    <RowWrapper
      inlineStyle={style}
      inlineCSS={css}
      className={`row ${className}`}
    >
      {children}
    </RowWrapper>
  );
};

export default Row;
